import { SessionAssignmentError, SessionBusinessArea, ServiceSessionDay } from 'model/ServiceSession';

export interface ServiceSessionsState {
    businessArea?: SessionBusinessArea;
    startDate?: string;
    endDate?: string;
    days: Array<ServiceSessionDay>;
    status: ServiceSessionsStatus;
    loading: boolean;
    saving: boolean;
    warnings: Array<string>;
    assignmentErrors: Array<SessionAssignmentError>;
    error?: string;
}

export enum ServiceSessionsStatus {
    Initial,
    Fetching,
    FetchSuccess,
    Saving,
    SaveSuccess,
    Error
}
